import type { PropsWithChildren } from 'react'

export interface ParameterProps {
  name: string
}

export const Parameter: React.FC<PropsWithChildren<ParameterProps>> = ({
  children,
  name,
}) => {
  return (
    <tr>
      <td className="w-1/4 px-6 py-3 text-left align-top">
        <strong>{name}</strong>
      </td>
      <td className="w-3/4 space-y-4 px-6 py-3 text-left align-top">
        {children}
      </td>
    </tr>
  )
}
